import { ImagePathWithRenditions } from './ImageTypes';
import { ProductLister } from './product-lister';
import { ProductDeliveryPromiseExplanations, ProductTileVerticalFormat } from './product-detail';
import { CdnSettings } from './AemConfigurationTypes';

type CampaignGroupSlidesViewports =
  | 'default'
  | 'mobile'
  | 'mobileLarge'
  | 'tabletSmall'
  | 'tablet'
  | 'desktop'
  | 'desktopLarge';

export type CampaignGroupFallbackProduct = {
  productCode: string;
  productColour: string;
};

export type CampaignGroupMultipleProduct = {
  productCode: string;
  productColour: string;
  fallbackProducts?: Array<CampaignGroupFallbackProduct>;
};

export enum CampaignGroupTileType {
  PRODUCT = 'product',
  IMAGE = 'image',
  TEXT = 'text',
}

export enum CampaignGroupOpenAs {
  LINK = 'link',
  MINI_PDP = 'minipdp',
  NONE = 'none',
  MINI_PDP_MULTI = 'minipdp-multiple-products',
}

export type CampaignGroupTile = {
  productCode: string;
  productColour?: string;
  fallbackProducts?: Array<CampaignGroupFallbackProduct>;
  href?: string;
  openAs: CampaignGroupOpenAs;
  image?: ImagePathWithRenditions;
  product?: ProductLister;
  imageLabel?: string;
  text?: string;
  type: CampaignGroupTileType;
  uniqueId?: string;
  queryParameters?: string;
  multipleProducts?: Array<CampaignGroupMultipleProduct>;
  title?: string;
  images?: Array<ImagePathWithRenditions>;
  shortDescription?: string;
};

export type CampaignGroupProperties = {
  /** Use dark or light (default) color for arrows */
  arrowColours: 'light' | 'dark';
  /** Not sure why? */
  defaultTile: number;
  /** Whether or not to display arrow on desktop for floating slider. */
  displayArrows: boolean;
  /** Hide on desktop */
  hideForDesktop: boolean;
  /** Hide on mobile/tablet small */
  hideOnViewports: boolean;
  /** Add spacing between the images in the slider */
  innerSpacing: boolean;
  /** Please, indicate whether you want to show progress bar for slider with arrows or for a slider with a floating image for desktop. */
  showIndicators: boolean;
  /** Number of slides to scroll per click / swipe */
  slidesToScroll: Record<CampaignGroupSlidesViewports, number>;
  /** Number of slides to show */
  slidesToShow: Record<CampaignGroupSlidesViewports, number>;
  subTitle?: string;
  title?: string;
  type: 'floating' | 'arrows';
  tiles: Array<CampaignGroupTile>;
  deliveryPromiseExplanations: ProductDeliveryPromiseExplanations;
  cdnSettings?: CdnSettings;
  mainWebshopId: number;
  productTileFormat: ProductTileVerticalFormat;
  showCompare?: boolean;
};
